import NewOriginForm from './NewOriginForm';

export default NewOriginForm;
